module.exports = "<svg class=\"icon <%= cls %>\"><use xlink:href=\"<%= svgSpritePath %>#<%= icon %>\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/cigna-frontend/js/views/svg.tpl.html
// module id = Vi7H
// module chunks = 4